module.exports = __webpack_public_path__ + "static/Sushasan_insta_logo-1c0e3e4a313bb473b179d4eb0cf216ba.png";